import React from "react";
import { useNavigate, Link } from "react-router-dom";
import cn from "classnames";
import InfoPage from ".";
import './HostTypeSelect.sass';

const HostTypeSelect = () => {
  const navigate = useNavigate();

  const below = (
    <div className="host-type-select-container">
      <h2>
        What type of host are you?
      </h2>
      <div>
        Select your category to personalize your signup.
      </div>
      <div>
        <button 
          className={cn('button-navy')} 
          onClick={() => navigate('/host-signup?category=vacation_rental')}
        >
          Vacation Rental
        </button>
        <button 
          className={cn('button')} 
          onClick={() => navigate('/host-signup?category=boutique_hotel')}
        >
          Boutique Hotel
        </button>
        <button 
          className={cn('button-stroke')} 
          onClick={() => navigate('/host-signup?category=tourism_board')}
        >
          Tourism Board
        </button>
      </div>
      <div className="host-type-select-login-text">
        <div>or</div>
        <Link to="/host-login">Login</Link>
      </div>
    </div>
  );

  return (
    <InfoPage title="" below={below} tallOverride={false} customMinHeight={700} disableStamps />
  );
};

export default HostTypeSelect;


